angular.module('impactx.basket').controller('EnterOffercodeCtrl', EnterOffercodeCtrl);

EnterOffercodeCtrl.$inject = ['$scope', '$mdDialog', 'trns', 'dataGen', 'TranslationService', 'ToastService', '$redirect', '$context'];

function EnterOffercodeCtrl($scope, $mdDialog, trns, dataGen, TranslationService, ToastService, $redirect, $context)
{
    var self = this;
    self.wizardIndexEnterCode = 0;
    self.wizardIndexChangeName = 1;
    self.wizardIndexChoose = 2;
    self.changedName = false;
    self.targetHeaderWarning = null;
    self.checkingWarning = false;
    $scope.wizardIndex = self.wizardIndexEnterCode;

    $scope.trns = trns;

    self.trns = {forward: TranslationService.get("forward")};

    self.cancel = function () {
        self.changedName ? $mdDialog.hide() : $mdDialog.cancel();
    };

    self.checkOfferCode = function ()
    {
        dataGen.postAsForm({}, {code: self.code}, '/basket/checkcode').then(function (data) {
            $scope.data = data.data;
            self.trns.notValidCode = data.trns.notValidCode;
            self.trns.details = data.trns.details;
            self.trns.chooseOffer = data.trns.chooseOffer;
            self.trns.chooseAndAddToBasket = data.trns.chooseAndAddToBasket;
            $scope.wizardIndex = $scope.data.isImported ? self.wizardIndexChangeName : self.wizardIndexChoose;
            if($scope.wizardIndex === self.wizardIndexChoose) {
                self.details();
            }
        });
    };

    self.checkExistingSupplierForTargetHeader = function (selected)
    {
        self.targetHeaderWarning = null;
        if (selected && selected.id > 0) {
            self.checkingWarning = true;
            dataGen.getData({}, {rfqhId: selected.id, rfqsId: $scope.data.rfqsId}, '/rfx/rfqs/targetheader/checkExistingSupplier').then(function (data) {
                if (data.data.warning) {
                    self.targetHeaderWarning = data.data.warning;
                }
                self.checkingWarning = false;
            }, function () {
                self.checkingWarning = false;
            });
        }
    };

    self.changeName = function ()
    {
        dataGen.postAsForm({}, {checkData: $scope.data}, '/basket/code/changename').then(function (data) {
            self.changedName = true;
            $scope.data = data.data;
            self.details();
        });
    };

    self.details = function ()
    {
        $mdDialog.cancel();
        if ($scope.data.canViewOffer) {
            $redirect.redirectTo(null, "rfx/offer/" + $scope.data.rfqsId);
        }
        else {
            $redirect.redirectTo(null, "rfxbuyer/" + $scope.data.headerId);
        }
    };

    self.chooseOffer = function ()
    {
        dataGen.postAsForm({}, {rfqsId: $scope.data.rfqsId}, "/rfx/buyer/decide").then(function () {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            $mdDialog.hide();
        });
    };

    self.chooseAndAddToBasket = function ()
    {
        dataGen.postAsForm({}, {code: $scope.data.code}, '/basket/addcode').then(function () {
            $context.refreshBasket({}, dataGen, $context);
            ToastService.openStandardToast(TranslationService.get("addSuccess"));
            $mdDialog.hide(true);
        });
    };
}